<template>

  <nav class="navbar navbar-dark bg-dark navbar-expand-lg" v-if="user.id && !$_store.state.routerPrizedraw">
    <div class="container-fluid">
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item" >
            <router-link to="/" class="navbar-brand text-light logoNav">
              <img
                src="../assets/logo2.png"
                alt=""
                class=""
              />
            </router-link>
          </li>
          <li v-if="!user.type_user.includes('A')" class="nav-item ms-2">
            <router-link to="/ponto" class="nav-link text-white ponto">
              Ponto eletronico
            </router-link>
          </li>
            
          <li v-if="user.type_user.includes('A')" class="nav-item dropdawn">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item dropdown dropleft">
                  <a
                    class="nav-link dropdown-toggle text-white option"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Processos
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                      @click="navigateAndReload('/register-process')"
                        class="text-light dropdown-item clickable"
                        >Designer</a
                      >
                    </li>
                    <li>
                      <a
                        @click="navigateAndReload('/printer')"
                        class="dropdown-item clickable"
                        >Impressor
                      </a
                      >
                    </li>
                    <li>
                      <a
                      @click="navigateAndReload('/delivery')"
                        class="dropdown-item clickable"
                        >Entrega</a
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li v-if="user.type_user.includes('A')" class="nav-item">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item dropdown dropleft">
                  <a
                    class="nav-link dropdown-toggle text-white option"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Usuários
                  </a>
                  <ul class="dropdown-menu">
                    <li v-if="user.type_user === 'A'">
                      <router-link
                        to="/generate-token"
                        class="text-light dropdown-item"
                        >Gerar Token de Acesso</router-link
                      >
                    </li>
                    <li>
                      <router-link to="/list-users" class="dropdown-item"
                        >Lista de Usuários</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li v-if="user.type_user.includes('A')" class="nav-item">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item dropdown dropleft">
                  <a
                    class="nav-link dropdown-toggle text-white option"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Clientes
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        to="/register-client"
                        class="text-light dropdown-item"
                        >Registar novo cliente</router-link
                      >
                    </li>
                    <li v-if="user.type_user.includes('A')">
                      <router-link to="/list-clients" class="dropdown-item">
                        Lista de Clientes
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li v-if="user.type_user.includes('A')" class="nav-item">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item dropdown dropleft">
                  <a
                    class="nav-link dropdown-toggle text-white option"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Sorteio
                  </a>
                  <ul class="dropdown-menu">
                    <li v-if="user.type_user.includes('A')" class="navbar-nav">
                      <span v-if="!($_store.state.prizedraw)" class="dropdown-item">Sem Sorteio..</span>
                      <router-link v-else to="/prizedraw-start" class="dropdown-item">
                        Iniciar Sorteio
                      </router-link>
                    </li>
                    <li v-if="user.type_user.includes('A')" class="navbar-nav">
                      <router-link to="/prizedraw" class="dropdown-item">
                        Configurações do Sorteio
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li v-if="user.type_user.includes('A')" class="nav-item">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item dropdown dropleft">
                  <a
                    class="nav-link dropdown-toggle text-white option"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                  Dados de Produção
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        to="/material"
                        class="text-light dropdown-item"
                        >Material</router-link
                      >
                    </li>
                    <li v-if="user.type_user.includes('A')">
                      <router-link to="/machine" class="dropdown-item"
                        >Máquina</router-link
                      >
                    </li>
                    <li v-if="user.type_user.includes('A')">
                      <router-link to="/estoque" class="dropdown-item"
                        >Estoque</router-link
                      >
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
          <li v-if="user.type_user == 'I'" class="nav-link text-white ">
            <router-link class="dropdown-item" to="/machine">Máquina</router-link>
          </li>
          <li v-if="user.type_user.includes('A')" class="nav-item">
            <div class="collapse navbar-collapse" id="navbarSupportedContent">
              <ul class="navbar-nav mb-2 mb-lg-0">
                <li class="nav-item dropdown dropleft">
                  <a
                    class="nav-link dropdown-toggle text-white option"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Ferramentas
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <a href="https://calcularprecos.netlify.app" target="_blank" class="dropdown-item">
                        Calculadora de Preços
                      </a>
                    </li>
                    <li v-if="user.type_user.includes('A')">
                      <a href="http://www.copycenterdigital.com.br:8082/" target="_blank" class="dropdown-item">
                        Gerador Cupom
                      </a>
                    </li>
                    <li v-if="user.type_user === 'A'">
                      <router-link to="/dashboard" class="dropdown-item">
                        Dashboard
                      </router-link>
                    </li>
                    <li v-if="user.type_user.includes('A')" class="navbar-nav">
                      <router-link to="/ponto" class="dropdown-item">
                        Ponto eletronico
                      </router-link>
                    </li>
                    <li v-if="user.type_user.includes('A')" class="navbar-nav">
                      <router-link to="/data_manipulation" class="dropdown-item">
                        Manipulação de Dados
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

      <div class="d-flex align-items-center">

        <div
          class="dropdown notif-bell-wrapper me-3"
          v-if="user.type_user && !user.type_user.includes('D')"
        >
          <button
            class="btn notif-bell-btn position-relative"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            aria-label="Pedidos prontos"
          >
            <span
              v-if="totalReadyOrders > 0"
              class="badge rounded-pill bg-danger notif-badge"
            >
             <font-awesome-icon icon="truck-fast" class="text-white notif-bell-icon" />
              {{ totalReadyOrders }}
            </span>
          </button>

          <ul class="dropdown-menu dropdown-menu-end notif-panel">
            <li class="notif-panel-title px-3 py-2">Pedidos prontos</li>

            <li class="px-3 py-2" @click.stop>
              <input
                type="text"
                class="form-control form-control-sm notif-search"
                placeholder="Buscar por cliente..."
                v-model="searchClient"
              />
            </li>

            <li v-if="clientsWithReady.length === 0" class="px-3 py-2 text-secondary">
              Nenhum pedido pronto no momento.
            </li>

            <li
              v-else-if="filteredClientsWithReady.length === 0"
              class="px-3 py-2 text-secondary"
            >
              Nenhum cliente encontrado para "{{ searchClient }}".
            </li>

            <li v-for="clientItem in filteredClientsWithReady" :key="clientItem.id">
              <a
                class="dropdown-item notif-client-header d-flex justify-content-between align-items-center"
                href="#"
                @click.prevent.stop="toggleClientExpand(clientItem.id)"
              >
                <span>
                  <i class="fa-solid fa-box me-2"></i>
                  {{ clientItem.name }}
                </span>
                <span class="d-flex align-items-center">
                  <span class="badge bg-success me-2">{{ clientItem.readyProcesses.length }}</span>
                  <i
                    class="fa-solid"
                    :class="expandedClients[clientItem.id] ? 'fa-chevron-up' : 'fa-chevron-down'"
                  ></i>
                </span>
              </a>

              <ul v-if="expandedClients[clientItem.id]" class="notif-client-items">
                <li
                  v-for="processItem in clientItem.readyProcesses"
                  :key="processItem.id"
                  class="notif-client-item d-flex justify-content-between align-items-center"
                >
                  <span
                    class="clickable"
                    @click="viewProcessFromNotif(processItem.id)"
                  >
                    N° {{ 1000 + processItem.id }} - {{ getMaterial(processItem) }}
                  </span>

                  <font-awesome-icon
                    icon="truck-fast"
                    class="text-success ms-2 clickable"
                    title="Finalizar entrega"
                    data-bs-toggle="modal"
                    href="#deliveryModalNavBar"
                    role="button"
                    @click.stop="setProcess(processItem)"
                  />
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!-- fim notificação de pedidos prontos -->

        <div class="userNav" v-if="user">
          <router-link to="/view-user" class="nav-link"
            >Bem-vindo - {{ user.name }}
          </router-link>
        </div>

        <div
          class="collapse navbar-collapse userFinish"
          id="navbarSupportedContent"
        >
          <ul class="navbar-nav mb-2 mb-lg-0">
            <li class="nav-item dropdown dropleft me-5">
              <button
                class="nav-link dropdown-toggle btn-hover"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="m-1 fa-solid fa-circle-user text-dark"></i>
              </button>
              <ul class="dropdown-menu">
                <li v-if="user" class="">
                  <a class="dropdown-item text-center clickable" @click="exit()"
                    >Sair <i class="fa-solid fa-arrow-right-from-bracket"></i
                  ></a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <!-- Modal de finalizar entrega - compartilhado entre a NavBar (notificação) e a tela de Entrega -->
  <div class="modal fade" 
    id="deliveryModalNavBar" 
    aria-hidden="true" 
    aria-labelledby="deliveryModalNavBarLabel" 
    tabindex="-1"
    style="max-height: 600px; margin-top: 40px;"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 
            class="modal-title" 
            id="deliveryModalNavBarLabel">
            Finalizar entrega do serviço - N° {{ 1000 + process?.id }}
          </h5>
          <button 
            type="button" 
            class="btn-close" 
            data-bs-dismiss="modal" 
            aria-label="Close"
            @click="closeDelivery"
          >
          </button>
        </div>
        <div class="modal-body">

          <div class="ps-2 pe-2 mb-3">
            <label for="name" class="form-label">Responsável</label>
            <input
              type="text"
              class="form-control"
              id="name"
              :placeholder="$_store.state.userCurrent.name"
              readonly
            />
          </div>

          <div class="ps-2 pe-2 mb-3">
            <label for="type" class="form-label"
              >Tipo da entrega</label
            >
            <select id="type" v-model="payload.type_delivery" class="form-control">
              <option value="" selected>Selecione o tipo de Entrega...</option>
              <option value="U">Uber</option>
              <option value="M">Motoboy</option>
              <option value="R">Rodoviária</option>
              <option value="C">Cliente</option>
            </select>
          </div>

          <div class="ps-2 pe-2 mb-3">
            <label for="comment">Observação <small>(opcional)</small></label>
            <textarea
              v-model="payload.observer"
              class="form-control"
              id="comment"
              rows="3"
            >
            </textarea>
          </div>
          <div class="d-flex justify-content-center mb-2">
            <button 
                class="btn btn-outline-dark me-1 col-6" 
                @click="sendDelivery(loadReadyOrders)"
                :disabled="!payload.type_delivery ? true : false"
            >
              Finalizar
            </button>
            <button 
              class="btn btn-outline-danger ms-1 col-6" 
              @click="closeDelivery"
              id="closeButtonDelivery"
              data-bs-dismiss="modal" 
              aria-label="Close"
            >
              Cancelar
            </button>
          </div> 

        </div>
      </div>
    </div>
  </div>

  <router-view />
</template>

<script>
import { computed, watch, onMounted, reactive, ref } from "vue";
import { useRouter } from 'vue-router';
import store from "../store";
import { getMaterialInList, normalizeText } from "../utils";
import { useDelivery } from "@/composables/sendDelivery";
import {
  getReponseClients,
  getReponseMaterial,
  getReponseNotification,
  getReponseStageProcess,
  getReponseProcess,
} from "../socket";

export default {
  name: "NavBar",
  props: {},
  setup() {
    const user = computed(() => store.state.userCurrent);
    const router = useRouter();
    const expandedClients = reactive({});
    const materials = computed(() => store.state.materialListView);

    // Estado/ações de entrega compartilhados com ListClient.vue
    const { process, payload, setProcess, closeDelivery, sendDelivery } = useDelivery();

    const clientsWithReady = computed(() => {
      const list = Array.isArray(store.state.executeProcessesDelivery)
        ? store.state.executeProcessesDelivery
        : [];

      return list
        .map((clientItem) => ({
          id: clientItem.id,
          name: clientItem.name,
          readyProcesses: (clientItem.processes || []).filter(
            (processItem) => processItem.stage === 'E'
          ),
        }))
        .filter((clientItem) => clientItem.readyProcesses.length > 0);
    });

    const totalReadyOrders = computed(() =>
      clientsWithReady.value.reduce(
        (total, clientItem) => total + clientItem.readyProcesses.length,
        0
      )
    );

    const searchClient = ref("");

    const filteredClientsWithReady = computed(() => {
      const search = normalizeText(searchClient.value || "");
      if (!search) return clientsWithReady.value;

      return clientsWithReady.value.filter((clientItem) =>
        normalizeText(clientItem.name || "").includes(search)
      );
    });

    const getMaterial = (processItem) => getMaterialInList(materials.value, processItem);

    const toggleClientExpand = (clientId) => {
      expandedClients[clientId] = !expandedClients[clientId];
    };

    const viewProcessFromNotif = (processId) => {
      router.push('/view-process/' + processId);
    };

    const loadReadyOrders = async () => {
      if (!user.value?.id) return;

      await store.dispatch('getProcessesDelivery');

      const list = Array.isArray(store.state.executeProcessesDelivery)
        ? store.state.executeProcessesDelivery
        : [];

      const materialIds = [];
      for (const clientItem of list) {
        for (const processItem of clientItem.processes || []) {
          materialIds.push(processItem.material);
        }
      }

      if (materialIds.length) {
        await store.dispatch('getMaterialListView', materialIds);
      }
    };

    onMounted(async () => {
      await loadReadyOrders();
      getReponseClients();
      getReponseMaterial();
      getReponseNotification();
      getReponseStageProcess();
      getReponseProcess();
    });

    watch(
      () => store.state.executeProcessesDelivery,
      (newValue) => {
        if (newValue?.reflash) {
          loadReadyOrders();
        }
      }
    );
    // --- fim notificação de pedidos prontos ---

    const exit = () => {
      sessionStorage.clear();
      location.reload();
    };

    const navigateAndReload = (route) => {
      router.push(route).then()
    }

    watch(
      () => [user.value.id, user.value.type_user],
      async ([newId], [oldId] = []) => {
        if (!user.value.type_user) return;
        if (newId === oldId) return;
        await store.dispatch('onGetPrizeDraw');
        await store.dispatch('onGetPrizeDrawClient');
        await store.dispatch('setMachineListCurrent');
        await loadReadyOrders();
      },
      { immediate: true }
    );

    watch(
      () => router.currentRoute.value.fullPath,
      (newFullPath) => {
        if (newFullPath === '/prizedraw-start') {
          store.commit('setRouterPrizedraw', true);
        } else {
          store.commit('setRouterPrizedraw', false);
        }
      },
      { immediate: true }
    );

    return {
      exit,
      user,
      navigateAndReload,
      clientsWithReady,
      filteredClientsWithReady,
      searchClient,
      totalReadyOrders,
      expandedClients,
      toggleClientExpand,
      viewProcessFromNotif,
      getMaterial,
      loadReadyOrders,
      process,
      payload,
      setProcess,
      closeDelivery,
      sendDelivery,
    };
  },
};
</script>

<style scoped>
/*colocar o estilo da página ou componente*/
img {
  margin-left: 100px;
  width:134px;
}

@media screen and (max-width: 992px) {
  img {
    margin-left: 0;
    margin-top: 15px;
    width:100px;
  }
}

.userNav {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 15px;
  font-weight: bold;
  color: white;
}

.userFinish {
  margin-right: 70px;
}

.userNav:hover {
  color: #bdbdbd;
  border-bottom: #f4f4f4 solid 2px !important; 
  border-radius: 4px;
}

.dropdown-menu {
  /* Define a largura mínima e a cor de fundo do dropdown */
  min-width: 100px;
  background-color: #212529;
}

.dropdown-item {
  color: white;
}

.dropdown-item:hover {
  background-color: #212529;
  color: #bdbdbd;
  font-weight: bold;
  border-bottom: #f4f4f4 solid 2px !important; 
  border-radius: 4px;
}
.clickable {
  cursor: pointer;
}

.option {
  color: white;
}

.option:hover{
  background-color: #212529; 
  color: #bdbdbd;
  font-weight: bold;
  border-bottom: #f4f4f4 solid 2px !important; 
  border-radius: 5px;
}

.btn-hover{
  color: white;
}

.btn-hover:hover{
  font-weight: bold;
  color: #737374; 
}

.ponto:hover {
  background-color: #212529;
  color: #bdbdbd;
  font-weight: bold;
  border-bottom: #f4f4f4 solid 2px !important; 
  border-radius: 4px;
}

.notif-bell-btn {
  background: transparent;
  border: none;
  font-size: 18px;
  padding: 6px 8px;
}

.notif-bell-icon {
  font-size: 14px;
}

.notif-badge {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 10px;
  padding: 3px 6px;
}

.notif-panel {
  background-color: #212529;
  min-width: 300px;
  max-height: 400px;
  overflow-y: auto;
  padding: 0;
}

.notif-panel-title {
  color: white;
  font-weight: bold;
  border-bottom: 1px solid #3a3a3a;
}

.notif-client-header {
  color: white;
}

.notif-client-header:hover {
  background-color: #2c3034;
  color: #bdbdbd;
}

.notif-client-items {
  list-style: none;
  padding: 4px 16px 8px 44px;
  margin: 0;
  background-color: #17191c;
}

.notif-client-item {
  color: #cfcfcf;
  font-size: 13px;
  padding: 4px 0;
}

.notif-search {
  background-color: #17191c;
  color: white;
  border: 1px solid #3a3a3a;
}

.notif-search::placeholder {
  color: #8c8a8a;
}

.notif-search:focus {
  background-color: #17191c;
  color: white;
  border-color: #5f5e5a;
  box-shadow: none;
}
</style>